import SalesActivityActionCreators from "../../store/actions/SalesActivity";
import {
	SalesActivity,
	GetOneSaleActivityRequest
} from "@/Contracts/Others/SalesActivity";
// import { useLocation } from "react-router-dom";
import { ZomentumRoutes } from "@/Contracts";
import useRefreshSalesActivity from "./useRefreshSalesActivity";
import { useSalesActivityModuleDispatch } from "../../store";
import { useContext } from "react";
import { ParentContext } from "../../store/context/ParentContext";
import { isPartnerApp } from "@/Utils";
import { getAppPathname } from "@/Utils/routing/getAppPathname";

const useHandleAddSalesActivity = (): Record<string, any> => {
	const parentContext = useContext(ParentContext);
	const { currentActiveOpportunity } = parentContext.opportunity;
	const { companyUserList } = parentContext.user;

	const dispatch = useSalesActivityModuleDispatch();
	// const location = useLocation();
	const refreshSalesActivity = useRefreshSalesActivity();

	const fetchUpdatedOpportunities = (opportunityId?: string) => {
		parentContext.opportunity.syncKanbanOpportunityDataById(
			opportunityId || (currentActiveOpportunity?.id ?? "")
		);
	};

	const handleAddSalesActivity = async (
		salesActivity: SalesActivity,
		opportunityId?: string
	) => {
		try {
			if (getAppPathname() === ZomentumRoutes.SalesActivityPage) {
				const taskActivity = await dispatch(
					SalesActivityActionCreators.fetchOneSalesActivity(
						new GetOneSaleActivityRequest(
							salesActivity.id,
							salesActivity.feed_type
						),
						companyUserList
					)
				);
				await dispatch(
					SalesActivityActionCreators.addActivityToUsersSalesActivity(
						taskActivity.salesActivity
					)
				);
			} else if (
				getAppPathname() === ZomentumRoutes.OpportunityList ||
				getAppPathname() === ZomentumRoutes.VendorOpportunityList
			) {
				fetchUpdatedOpportunities(opportunityId);
			} else if (
				getAppPathname().startsWith(
					`${ZomentumRoutes.OpportunityList}/`
				) ||
				getAppPathname().startsWith(`${ZomentumRoutes.ClientsList}/`) ||
				getAppPathname().startsWith(
					`${ZomentumRoutes.VendorOpportunityList}/`
				) ||
				getAppPathname().startsWith(
					`${ZomentumRoutes.VendorClientList}/`
				) ||
				getAppPathname().startsWith(
					`${ZomentumRoutes.VendorPartnerList}/`
				)
			) {
				refreshSalesActivity();
			}
		} catch (error) {
			console.error(error);
		}
	};

	const handleCloseAddSalesActivity = () => {
		if (
			getAppPathname() === ZomentumRoutes.OpportunityList &&
			isPartnerApp()
		) {
			parentContext.opportunity.resetOpportunityDetails();
		} else if (
			getAppPathname() === ZomentumRoutes.ClientsList &&
			isPartnerApp()
		) {
			parentContext.client.resetClientDetails();
		} else if (
			getAppPathname().startsWith(`${ZomentumRoutes.OpportunityList}/`) ||
			getAppPathname().startsWith(`${ZomentumRoutes.ClientsList}/`) ||
			getAppPathname().startsWith(
				`${ZomentumRoutes.VendorPartnerList}/`
			) ||
			getAppPathname().startsWith(
				`${ZomentumRoutes.VendorOpportunityList}/`
			)
		) {
			refreshSalesActivity();
		}
	};

	return {
		handleAddSalesActivity,
		handleCloseAddSalesActivity
	};
};

export default useHandleAddSalesActivity;
